import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AjaxObservableService } from '../services/ajax-observable.service';
import { UserDetailsService } from '../services/user-details.service';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Utility } from '../shared/utility/utility';
import { EmitterService } from '../services/emitter.service';
import { takeUntil, filter } from "rxjs/operators";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ZendeskService {
  isUserLoggedIn = false;
  isVipUser = false;
  destroy$: Subject<boolean> = new Subject<boolean>();

  zendeskEnabledOptions = environment.zendeskServiceConfig["chatEnabledLanguages"];
  zendeskNonVipTags = environment.zendeskServiceConfig["chatTags"];
  zendeskVipTags = environment.zendeskServiceConfig["chatTagsForVip"];
  zendeskScriptPath = environment.zendeskServiceConfig["scriptPath"];

  constructor(
    private ajaxObservableService: AjaxObservableService,
    private userDetailsService: UserDetailsService,
    private emitterService: EmitterService,
    private utils: Utility,
  ) {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.isUserLoggedIn = loginStatus;
      window["zESettings"] = null;
      let zE = window['zE']
      let $zopim = window['$zopim'];
      let snippetEleRef = document.getElementById("ze-snippet");
      if (zE && $zopim && snippetEleRef) {
        zE('webWidget', 'hide');
        snippetEleRef.remove();
      }
    });

  }

  detectZenDeskChatLanguage() {
    var langCode = 'en';
    if (localStorage.getItem("langCode")) {
      langCode = localStorage.getItem("langCode").substr(0, 2).toLowerCase();
    }
    switch (langCode) {
      case 'de':
        return this.zendeskEnabledOptions["de"];
      case 'fi':
        return this.zendeskEnabledOptions["fi"];
      case 'no':
        return this.zendeskEnabledOptions["no"];
      case 'pl':
        return this.zendeskEnabledOptions["pl"];
      default:
        return this.zendeskEnabledOptions["en"];
    }
  }

  showChat() {
    this.zendeskEnabledOptions = environment.zendeskServiceConfig["chatEnabledLanguages"];
    let self = this;
    let zE = window['zE'];
    let $zopim = window['$zopim'];

    zE(function () {
      $zopim(function () {
        var langCode = 'en';
        if (localStorage.getItem("langCode")) {
          langCode = localStorage.getItem("langCode").substr(0, 2).toLowerCase();
        }
        switch (langCode) {
          case 'de':
            $zopim.livechat.departments.setLabel(self.zendeskEnabledOptions["de"]);
            zE('webWidget', 'setLocale', 'de');
            break;
          case 'fi':
            $zopim.livechat.departments.setLabel(self.zendeskEnabledOptions["fi"]);
            zE('webWidget', 'setLocale', 'fi');
            break;
          case 'no':
            $zopim.livechat.departments.setLabel(self.zendeskEnabledOptions["no"]);
            zE('webWidget', 'setLocale', 'no');
            break;
          case 'pl':
            $zopim.livechat.departments.setLabel(self.zendeskEnabledOptions["pl"]);
            zE('webWidget', 'setLocale', 'pl');
            break;
          default:
            $zopim.livechat.departments.setLabel(self.zendeskEnabledOptions["en"]);
            zE('webWidget', 'setLocale', 'en');
            break;
        }
        zE('webWidget', 'show');
        zE('webWidget', 'open');

        //this watches for the chat ending then closes the chat widget
        zE('webWidget:on', 'close', function () {
          zE('webWidget', 'hide');
        })
      });
    });
  }

  //function to initialize and open the chat
  initChat() {
    let self = this;
    let zE = window['zE'];
    let $zopim = window['$zopim'];
    let snippetEleRef = document.getElementById("ze-snippet");

    //check if the script was already loaded.
    if (zE && $zopim && snippetEleRef) {
      this.showChat();
      return;
    }

    //dynamically load the script
    var zenDeskScript = document.createElement("script");
    zenDeskScript.id = "ze-snippet";
    zenDeskScript.src = this.zendeskScriptPath;
    document.head.appendChild(zenDeskScript);

    //the rest of the script needs to run after the script has loaded.
    document.getElementById("ze-snippet").addEventListener("load", function () {
      self.updateZendeskConfig();
      zE = window['zE'];
      zE(function () {
        $zopim = window['$zopim'];
        $zopim(function () {
          //if we are logged in and have a JWT
          //then call the authenticate() function()
          //NOTE: this must be the first call to any of the Zen Desk script functions
          //NOTE: and should not be call if the user doesn't have a JWT
          if (sessionStorage.getItem("user")) {
            $zopim.livechat.authenticate({
              jwtFn: function (callback) {
                self.getZendeskToken().subscribe(data => {
                  if (data && data['status'] === 'SUCCESS') {
                    callback(data["jwtToken"]);
                  }
                });
              }
            });
            self.proactiveChat();
          }

          // $zopim.livechat.window.show();
          setTimeout(self.showChat, 250);
        });
      });
    });
  }

  proactiveChat() {
    let self = this;
    let zE = window['zE'];
    setInterval(function () {
      let userName;
      if (self.userDetailsService.getUserProfileDetails()) {
        userName = self.userDetailsService.getUserProfileDetails()["firstName"] + " " + self.userDetailsService.getUserProfileDetails()["lastName"];
      }
      self.getZendeskRubikoDetails(userName).subscribe(data => {
        if (data['proactive']) {
          var curHRef = window.location.href;
          var paIdx = curHRef.indexOf('proactive=');
          if (paIdx > 0) {
            var paIdxEnd = curHRef.indexOf('&', paIdx);
            curHRef = paIdxEnd <= 0 ? curHRef.substr(0, paIdx - 1) : (curHRef.substr(0, paIdx) + curHRef.substr(paIdxEnd + 1));
          }
          curHRef = curHRef + (curHRef.indexOf('?') < 0 ? '?' : '&') + 'proactive=' + data['proactive']
          window.history.replaceState(null, null, curHRef);
          zE('webWidget', 'updatePath');
          setTimeout(function () {
            zE('webWidget', 'show');
            zE('webWidget', 'open');
          }, 2000);
        }
      });

    }, 60000);
  }


  updateZendeskConfig() {
    let zE = window['zE'];
    // update the below varaible when user VIP status is found for now we dont have VIP details so kept it false.
    this.isVipUser = false;
    let chatObjectTags = this.isUserLoggedIn && this.isVipUser ? this.zendeskVipTags : this.zendeskNonVipTags;

    let chatObject = {
      webWidget: {
        chat: {
          // Set the departments / languages and set the default for the user
          departments: {
            enabled: Object.values(this.zendeskEnabledOptions),
            select: this.detectZenDeskChatLanguage()
          },
          tags: chatObjectTags,
        }
      }
    }

    if (!window["zESettings"]) {
      window["zESettings"] = chatObject;
    }

    if (zE) {
      zE('webWidget', 'updateSettings', { webWidget: { chatObject } });
    }
  }

  getZendeskToken(): Observable<any> {
    return this.ajaxObservableService.getZendeskToken().pipe(map(response => {
      return response;
    }), catchError(error => {
      return throwError(error);
    }))
  }

  getZendeskRubikoDetails(userName): Observable<any> {
    return this.ajaxObservableService.getZendeskRubikoDetails(userName).pipe(map(response => {
      return response;
    }), catchError(error => {
      return throwError(error);
    }))
  }

}
